import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {DictionaryPipe} from '../../shared/pipes/dictionary.pipe';

@Component({
    selector: 'app-pop-up-dialog',
    templateUrl: './pop-up-dialog.component.html',
    styleUrls: ['./pop-up-dialog.component.scss'],
    providers: [DictionaryPipe],
    standalone: false
})
export class PopUpDialogComponent implements OnInit {
  @Input() Message = '';
  @Input() minWidth = '400px';
  @Input() minHeight = '80px';
  @Input() Header;
  @Input() Display = false;
  @Input() confirmButton = 'OK';
  @Output() DisplayBack = new EventEmitter<boolean>();

  defaultHeaderText: string;

  constructor(private dictionaryPipe: DictionaryPipe) {
  }

  ngOnInit() {
    this.defaultHeaderText = this.dictionaryPipe.transform('MESSAGE');
  }

}
